import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import { getSingleEnquiryById, updateEnquiry } from "../../../redux/enquiries/action";

const UpdateEnquiry = () => {
  const { eqid } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const singleTicketDetails = useSelector(
    (state) => state?.reusableSlice?.getSingleEnquiryById
  );

  useEffect(() => {
    if (eqid) {
      dispatch(getSingleEnquiryById(eqid));
    }
  }, [eqid]);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name:
        singleTicketDetails && singleTicketDetails.name
          ? singleTicketDetails.name
          : "",
      email:
        singleTicketDetails && singleTicketDetails.email
          ? singleTicketDetails.email
          : "",
      message:
        singleTicketDetails && singleTicketDetails.message
          ? singleTicketDetails.message
          : "",
      status:
        singleTicketDetails && singleTicketDetails.status
          ? singleTicketDetails.status
          : "",
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });


  useEffect(() => {
    singleTicketDetails && formik.setFieldValue("status", singleTicketDetails.status)
  }, [singleTicketDetails])

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: eqid,
    };
    dispatch(updateEnquiry(data, setLoading));
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    formik.setFieldValue("status", Number(gender));
  };
  return (
    <div className="px-3">

      <div className=" category-wrapper">
        <h3 className="pb-3">Update Enquiry</h3>
        {!singleTicketDetails ? (
          <FullScreenLoader />
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <div className="row ">
              <div className="col-md-3 form-group">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter category title"
                  name="title"
                  disabled
                  value={formik.values.name}
                />
              </div>

              <div className="col-md-3 form-group">
                <label>Email</label>
                <input
                  type="text"
                  disabled
                  className="form-control"
                  placeholder="Enter email"
                  name="user_name"
                  value={formik.values.email}
                />
              </div>

              <div className="form-group col-md-3">
                <label htmlFor="status">Status</label>
                <select
                  id="status"
                  title="status"
                  className="form-control"
                  onChange={handleChangeStatus}
                  onBlur={formik.handleBlur}
                  value={formik.values.status}
                >
                  <option value="">Select Status</option>
                  <option value="1">Resolved</option>
                  <option value="0">Not Resolved</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="status">Message</label>
                <div>
                  <textarea
                    className="form-group col-md-12"
                    disabled
                    rows={5}
                    value={formik.values.message}
                  />
                </div>
              </div>
            </div>
            <div
              className="d-flex align-items-center justify-content-center mt-3  "
              style={{ columnGap: "20px" }}
            >
              <button
                className="submit-btn  "
                onClick={() => {
                  navigate("/enqurieslist");
                }}
                style={{ width: "max-content" }}
              >
                Back
              </button>
              <button
                className="submit-btn   "
                style={{ width: "max-content" }}
                type="submit"
              >
                {!loading ? "Submit" : <Spinner />}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}

export default UpdateEnquiry
